/*core module*/
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { APP_INITIALIZER } from '@angular/core';

/*project Component*/
import { AppComponent, HtmlreaderDirectiveHeader, HtmlreaderDirectiveFooter } from './app.component';
/*configuration file for the external json*/
import { ConfigService } from './config.service';
import { ConfigLoader } from './config-loader';

/**********************************************/
/*related to this specific project*/
import { RequirementsViewComponent,
	PageCategoryTitleComponent, PageCategoryTextComponent } from './requirements.component';
import { RequirementsTableComponent, ReqCategoryTextComponent, currDateComponent } from './requirements-table.component';

/*plug in*/


@NgModule({
	declarations: [
		HtmlreaderDirectiveHeader, HtmlreaderDirectiveFooter, 
		AppComponent, RequirementsViewComponent, RequirementsTableComponent, ReqCategoryTextComponent, currDateComponent,
		PageCategoryTitleComponent, PageCategoryTextComponent
  ],
  imports: [
	BrowserModule,
	HttpModule
  ],
  providers: [
	  ConfigService,
	  {
		  provide: APP_INITIALIZER,
		  useFactory: ConfigLoader,
		  deps: [ConfigService],
		  multi: true
	  }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts